export default __webpack_public_path__ + "static/media/fpbh0004.e52fd6b7.png";